function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionBonusProgramFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28.584 8.443a13.582 13.582 0 00-5.194-5.116c-2.187-1.225-4.663-1.833-7.417-1.827-2.754.004-5.228.622-7.41 1.854C6.376 4.587 4.653 6.298 3.39 8.49 2.127 10.685 1.495 13.15 1.5 16c.007 2.85.648 5.357 1.92 7.528a13.788 13.788 0 005.194 5.116c2.188 1.241 4.659 1.86 7.417 1.856 2.755-.004 5.229-.63 7.41-1.882a13.812 13.812 0 005.173-5.135c1.263-2.176 1.891-4.722 1.885-7.535-.006-2.814-.643-5.313-1.915-7.503v-.002zm-2.491 5.374l-4.476 4.35 1.137 6.15c.128.7-.639 1.229-1.274.877l-5.319-2.954-5.307 2.973c-.632.354-1.402-.172-1.277-.872l1.113-6.155-4.493-4.334c-.506-.488-.218-1.33.487-1.424l6.08-.821 2.581-5.59c.304-.66 1.262-.66 1.568-.004l2.605 5.582 6.08.799c.706.092.998.931.493 1.422l.002.001z",
    fill: props.color
  }));
}

export default SvgIconPromotionBonusProgramFilled;